import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Login from './pages/login';
import Signup from './pages/signup';
import Dashboard from './pages/main';
import My from './pages/my';
import PrivacyPolicy from './pages/privacyPolicy';
import About from './pages/About';
import Terms from './pages/Terms';
import ContactUs from './pages/ContactUs';
import FAQs from './pages/FAQs';
import AddCoins from './pages/AddCoins';
import ForgetPassword from './pages/ForgetPassword';
import ResetPassword from './pages/ResetPassword';
import PrivateRoute from './pages/PrivateRoute';
import CoinBalance from './pages/CoinBalance';
import AdminDashboard from './pages/AdminDashboard';
// import AddCoins from './pages/AddCoins';
import MyWallet from './pages/mywallet';
import EasyPaisa from './pages/EasyPaisa';
import EasyPaisaManual from './pages/EasyPaisaManual';
import EasyPaisaQR from './pages/EasyPaisaQR';
import JazzCash from './pages/JazzCash';
import JazzCashManual from './pages/JazzCashManual';
import JazzCashQR from './pages/JazzCashQR';
import Withdraw from './pages/Withdraw';
import Transaction from './pages/transaction';
import Profile from './pages/Profile';
import AdminBannerUploads from './pages/AdminBannerUpload';
import CreateMatchForm from './pages/CreateMatchForm';
import MatchList from './pages/MatchList';
import SlotSelectionPage from './pages/SlotSelectionPage';
import AdminMatchList from './pages/AdminMatchList';
import AllMatchTags from './pages/AllMatchTags';
import MatchesByTag from './pages/MatchesByTag';
import OngoingMatches from './pages/OngoingMatches';
import AdminMatchPlayersPage from './pages/AdminMatchPlayersPage';
import MatchResultUploader from './pages/MatchResultUploader';
import MatchResultsPage from './pages/MatchResultsPage';
import CompletedMatchesPage from './pages/CompletedMatchesPage';
import ImportantUpdates from './pages/ImportantUpdates';
import AdminUpdatesPanel from './pages/AdminUpdatesPanel';
import CoinsWon from './pages/CoinsWon';
import UpdateKills from './pages/UpdateKills';
import Leaderboard from './pages/Leaderboard';
import UserHistory from './pages/UserHistory';
import AdminHistory from './pages/AdminHistory';



const App = () => {
  // ✅ User ID, Token, aur Role ko state mein rakho taake refresh ke baad values persist karein
  const [userId, setUserId] = useState(null);
  const [token, setToken] = useState(null);
  const [role, setRole] = useState(null);

  useEffect(() => {
    const updateUserData = () => {
      const storedUserId = localStorage.getItem("userId");
      const storedToken = localStorage.getItem("token");
      const storedRole = localStorage.getItem("role");

      console.log("🔄 Updating from localStorage:", storedUserId, storedToken, storedRole);

      setUserId(storedUserId);
      setToken(storedToken);
      setRole(storedRole);
    };

    // Pehli dafa jab component mount ho, tab bhi update karo
    updateUserData();

    // Jab bhi `localStorage` update ho, yeh listener chalega
    window.addEventListener("storage", updateUserData);

    return () => {
      window.removeEventListener("storage", updateUserData);
    };
  }, []);

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/me"
          element={
            <PrivateRoute>
              <My />
            </PrivateRoute>
          }
        />
          <Route
          path="/updates"
          element={
            <PrivateRoute>
              <ImportantUpdates />
            </PrivateRoute>
          }
        />
  <Route
          path="/leadbd"
          element={
            <PrivateRoute>
              <Leaderboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/easypaisa"
          element={
            <PrivateRoute>
              <EasyPaisa />
            </PrivateRoute>
          }
        />
        <Route
          path="/easypaisaman"
          element={
            <PrivateRoute>
              <EasyPaisaManual />
            </PrivateRoute>
          }
        />
        <Route
          path="/contact"
          element={
            <PrivateRoute>
              <ContactUs />
            </PrivateRoute>
          }
        />
        <Route
          path="/easypaisaqr"
          element={
            <PrivateRoute>
              <EasyPaisaQR />
            </PrivateRoute>
          }
        />

{/* <Route 
path="/match/:matchId/slots" 
element={
  <PrivateRoute>
      <SlotSelectionPage />
    <PrivateRoute/>

} 
/> */}
<Route path="/match/:matchId/slots" element={
  <PrivateRoute>
  <SlotSelectionPage />
  </PrivateRoute>
  } />


          <Route
          path="/matchlist"
          element={
            <PrivateRoute>
              <MatchList />
            </PrivateRoute>
          }
        />
        <Route
          path="/withdraw"
          element={
            <PrivateRoute>
              <Withdraw/>
            </PrivateRoute>
          }
        />
         <Route
          path="/transaction"
          element={
            <PrivateRoute>
              <Transaction/>
            </PrivateRoute>
          }
        />
        <Route
          path="/jazzcash"
          element={
            <PrivateRoute>
              <JazzCash />
            </PrivateRoute>
          }
        />
         <Route
          path="/jazzcashmu"
          element={
            <PrivateRoute>
              <JazzCashManual />
            </PrivateRoute>
          }
        />
        <Route
          path="/matchhistory"
          element={
            <PrivateRoute>
              <UserHistory />
            </PrivateRoute>
          }
        />
        <Route
          path="/jazzcashqr"
          element={
            <PrivateRoute>
              <JazzCashQR />
            </PrivateRoute>
          }
        />
        <Route
          path="/privacy"
          element={
            <PrivateRoute>
              <PrivacyPolicy />
            </PrivateRoute>
          }
        />
        <Route
          path="/about"
          element={
            <PrivateRoute>
              <About />
            </PrivateRoute>
          }
        />
        <Route
          path="/terms"
          element={
            <PrivateRoute>
              <Terms />
            </PrivateRoute>
          }
        />
         <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        
          <Route
          path="/mywallet"
          element={
            <PrivateRoute>
              <MyWallet />
            </PrivateRoute>
          }
        />
        <Route
          path="/coin"
          element={
            <PrivateRoute>
              {userId && token ? (
                <CoinBalance userId={userId} token={token} />
              ) : (
                <div>Loading...</div> // Agar userId ya token null hai to ye show hoga
              )}
            </PrivateRoute>
          }
        />
        <Route
          path="/faqs"
          element={
            <PrivateRoute>
              <FAQs />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-coins"
          element={
            <PrivateRoute>
              <AddCoins />
            </PrivateRoute>
          }
        />
        <Route
          path="/all_tags"
          element={
            <PrivateRoute>
              <AllMatchTags />
            </PrivateRoute>
          }
        />
        <Route
          path="//tags/:tag"
          element={
            <PrivateRoute>
              <MatchesByTag />
            </PrivateRoute>
          }
        />
         <Route
          path="/joined-matches"
          element={
            <PrivateRoute>
              <OngoingMatches />
            </PrivateRoute>
          }
        />
         <Route
          path="/matchresultpage"
          element={
            <PrivateRoute>
              <MatchResultsPage />
            </PrivateRoute>
          }
        />

<Route
          path="/completematchpage"
          element={
            <PrivateRoute>
              <CompletedMatchesPage />
            </PrivateRoute>
          }
        />

{/* <Route
          path="/add"
          element={
            <PrivateRoute>
              <AddCoins />
            </PrivateRoute>
          }
        /> */}

        {/* ✅ Admin Route (Only for Admins) */}
        <Route
          path="/admin"
          element={
            role === "admin" ? (
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            ) : (
              <div>Access Denied</div> // Non-admin users ko ye show hoga
            )
          }
        />

<Route
          path="/adminupdate"
          element={
            role === "admin" ? (
              <PrivateRoute>
                <AdminUpdatesPanel />
              </PrivateRoute>
            ) : (
              <div>Access Denied</div> // Non-admin users ko ye show hoga
            )
          }
        />
<Route
          path="/adminbanner"
          element={
            role === "admin" ? (
              <PrivateRoute>
                <AdminBannerUploads />
              </PrivateRoute>
            ) : (
              <div>Access Denied</div> // Non-admin users ko ye show hoga
            )
          }
        />
        <Route
          path="/adminhistory"
          element={
            role === "admin" ? (
              <PrivateRoute>
                <AdminHistory />
              </PrivateRoute>
            ) : (
              <div>Access Denied</div> // Non-admin users ko ye show hoga
            )
          }
        />

<Route
          path="/CreateMatchForm"
          element={
            role === "admin" ? (
              <PrivateRoute>
                < CreateMatchForm/>
              </PrivateRoute>
            ) : (
              <div>Access Denied</div> // Non-admin users ko ye show hoga
            )
          }
        />
        <Route
          path="/updatekills"
          element={
            role === "admin" ? (
              <PrivateRoute>
                < UpdateKills/>
              </PrivateRoute>
            ) : (
              <div>Access Denied</div> // Non-admin users ko ye show hoga
            )
          }
        />
        <Route
        path="/Coinswon"
        element={
          role === "admin" ? (
            <PrivateRoute>
              < CoinsWon/>
            </PrivateRoute>
          ) : (
            <div>Access Denied</div> // Non-admin users ko ye show hoga
          )
        }
      />
        <Route
          path="/adminmatchlist"
          element={
            role === "admin" ? (
              <PrivateRoute>
                <AdminMatchList />
              </PrivateRoute>
            ) : (
              <div>Access Denied</div> // Non-admin users ko ye show hoga
            )
          }
        />
          <Route
          path="/adminmatchplayerpage"
          element={
            role === "admin" ? (
              <PrivateRoute>
                <AdminMatchPlayersPage />
              </PrivateRoute>
            ) : (
              <div>Access Denied</div> // Non-admin users ko ye show hoga
            )
          }
        />


<Route
          path="/MatchResultUploader"
          element={
            role === "admin" ? (
              <PrivateRoute>
                <MatchResultUploader />
              </PrivateRoute>
            ) : (
              <div>Access Denied</div> // Non-admin users ko ye show hoga
            )
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
